import { Client } from "@/Common/Api/Client";
import { TextAreaAutoSize } from "@/Common/Components/Inputs/TextAreaAutoSize";
import { Comment } from "@/Common/Models/Patient/Comment";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { MedicalRequestCommentsDisplay } from "./MedicalRequestCommentsDisplay";

interface IAddRequestCommentPopupComponentProps {
    requestId: string;
    leftPosition: number;
    topPosition: number;

    onSaveSucess?: (comment: Comment) => void;
    onClose: () => void;
}

class AddRequestCommentPopupComponentState {
    public comment: string;
    public comments: Comment[];
}

class AddRequestCommentPopupComponent extends React.Component<IAddRequestCommentPopupComponentProps, AddRequestCommentPopupComponentState> {
    constructor(props: IAddRequestCommentPopupComponentProps) {
        super(props);

        const initialState = new AddRequestCommentPopupComponentState();
        initialState.comment = "";
        this.state = initialState;
    }

    public componentDidMount(): void {
        this.loadComments(this.props.requestId);
    }

    private mutateState(mutation: (s: AddRequestCommentPopupComponentState) => void, then: () => void = null): void {
        const s = new AddRequestCommentPopupComponentState();
        mutation(s);
        this.setState(s, then);
    }

    public render(): JSX.Element {
        if (!this.state.comments)
            return null;

        const containerid = "outsidecontainer";
        const id = "requestcommentspopupcontroller";
        const overlayStyle: React.CSSProperties = {
            position: "absolute",
            left: "0",
            top: "0",
            width: "100vw",
            height: "100vh",
            zIndex: 99
        };
        const containterStyle: React.CSSProperties = {
            position: "absolute",
            left: this.props.leftPosition + "px",
            top: this.props.topPosition + "px"
        };

        const content = this.renderContent(this.state.comments);

        return (
            <div id={containerid} onClick={e => this.closeOnOutsideClick(e)} style={overlayStyle}>
                <div id={id} className="notes-modal" style={containterStyle} onClick={e => this.cancelClickPropagation(e)}>
                    {content}
                    <div className="notes-content-footer text-right">
                        <button
                            className="btn btn-default push-right-5"
                            onClick={() => this.props.onClose()}
                        >
                            {cacheStore.GetString("CancelLabel")}
                        </button>

                        <button
                            className="btn btn-primary"
                            disabled={false}
                            onClick={() => this.saveComment(this.props.requestId, this.state.comment)}
                        >
                            {cacheStore.GetString("NoteSubmitLabel")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private renderContent(comments: Comment[]): JSX.Element {
        const id = "requestcomment";

        return (
            <div style={{ padding: "15px 20px" }}>
                <h4>{cacheStore.GetString("CommentsLabel")}</h4>
                <MedicalRequestCommentsDisplay comments={comments} showLastItemBorder={true} />
                <div style={{ marginBottom: "5px" }}>
                    <TextAreaAutoSize
                        id={id}
                        onTextChangeCallback={(value: string) => this.mutateState(s => s.comment = value)}
                        value={this.state.comment}
                        maxHeight="150px"
                        disabled={false}
                    />
                </div>
            </div>
        );
    }

    private loadComments(requestId: string): void {
        if (isGuidNullOrUndefinedOrEmpty(requestId))
            return;

        const requestData = {
            RequestId: requestId
        };

        Client.Postv2(
            ServerOperations.Server.Myle_LoadMedicalRequestComments,
            requestData,
            response => {
                this.mutateState(s => {
                    s.comments = response.Comments;
                });
            },
            errorMsgs => sessionStore.showPopup(errorMsgs)
        );
    }

    private saveComment(requestid: string, comment: string): void {
        if (requestid && comment) {
            const requestData = {
                RequestId: requestid,
                Comment: comment
            };

            Client.Postv2(
                ServerOperations.Server.Myle_SaveMedicalRequestComment,
                requestData,
                response => {
                    if (response.Comment && this.props.onSaveSucess)
                        this.props.onSaveSucess(response.Comment);
                },
                errorMsgs => sessionStore.showPopup(errorMsgs)
            );
        }

        this.props.onClose();
    }

    private cancelClickPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private closeOnOutsideClick(e: React.MouseEvent): void {
        e.stopPropagation();
        this.props.onClose();
    }
}

export { AddRequestCommentPopupComponent };
